import './App.css';
import Home from './pages/Home';

function App() {
  return (
    <div className="text-center mt-5">
      <Home />
    </div>
  );
}

export default App;
